import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { StaffsHelpbuttonService } from 'src/app/services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { StaffBasic } from 'src/app/models/helpbutton-models/helpbutton-staff-basic.model';

@Component({
  selector: 'app-helpbutton-staffs-breadcrumb-filter-card',
  templateUrl: './helpbutton-staffs-breadcrumb-filter-card.component.html',
  styleUrls: ['./helpbutton-staffs-breadcrumb-filter-card.component.scss']
})
export class HelpbuttonStaffsBreadcrumbFilterCardComponent implements OnInit {

  @Input() staffs;
  centers;
  centersForm = new FormGroup({});

  constructor(private userStorageService: UserStorageService,
    private staffsService: StaffsHelpbuttonService) { }

  ngOnInit() {
    this.getCenters();
    if (this.userStorageService.getFilterStaffs()) {
      this.centersForm.patchValue(this.userStorageService.getFilterStaffs()['centersForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterStaffs({ centersForm: this.centersForm.getRawValue() });
    if (this.userStorageService.getFilterStaffs()['centersForm']['all']) {
      this.userStorageService.deleteFilterStaffs();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.staffs.forEach((d: StaffBasic) => {
      if (centers.indexOf(d.CenterName) === -1) {
        centers.push(d.CenterName);
        this.centersForm.addControl(d.CenterName, new FormControl(false));
      }
    });
    this.centers = centers;
  }

  public filter() {
    const staffs = {
      centersForm:
      {
        attribute: 'CenterName',
        values: []
      }
    };
    if (this.centersForm.get('all').value) {
      staffs['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    } else {
      Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { staffs['centersForm'].values.push(c[0]); }});
    }
    this.staffsService.filterStaffs(staffs);
  }
}
